import React from 'react';
import { motion } from 'framer-motion';
interface SectionHeaderProps {
  number?: string;
  title: string;
  subtitle?: string;
  align?: 'left' | 'center';
}
export function SectionHeader({
  number,
  title,
  subtitle,
  align = 'left'
}: SectionHeaderProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-100px'
  }} transition={{
    duration: 0.6
  }} className={`mb-12 ${align === 'center' ? 'text-center' : ''}`} data-id="element-182">
      {number && <span className="text-oxblood font-serif text-sm tracking-widest uppercase mb-4 block" data-id="element-183">
          {number}
        </span>}
      <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif text-ink mb-4 leading-tight" data-id="element-184">
        {title}
      </h2>
      {subtitle && <p className="text-ink-light text-lg md:text-xl max-w-3xl font-sans leading-relaxed" data-id="element-185">
          {subtitle}
        </p>}
    </motion.div>;
}